export const getLastPostSlug = (state) => state.lastPostSlug;
